import { render } from "./TraineeToTrainerAssessment.vue?vue&type=template&id=70f122e1"
import script from "./TraineeToTrainerAssessment.vue?vue&type=script&lang=js"
export * from "./TraineeToTrainerAssessment.vue?vue&type=script&lang=js"

import "./TraineeToTrainerAssessment.vue?vue&type=style&index=0&id=70f122e1&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__